import React, { Component } from 'react';
import { HollaExWrapper } from './style';
import { HOLLAEX_WHITE } from '../../config/media';
import { Player } from 'video-react';
import Shortcut from 'video-react/lib/components/Shortcut';
import BigPlayButton from 'video-react/lib/components/BigPlayButton';
import ControlBar from 'video-react/lib/components/control-bar/ControlBar';
import { backGround } from './Utils';
class Hollaex extends Component {
	constructor(props) {
		super(props);
		this.state = {
			currentObj: {currentVideo :'' ,bgCount :0 ,title: '' ,desc: '' ,btnTitle:'' ,link: '' ,posStyle:'',animationType:''}
		}
	}
	componentDidMount() {
		let bg=[];
		bg=backGround;
		let count=Math.floor(Math.random() * bg.length);
		this.setState({currentObj :
			{
			...this.state.currentObj,
			currentVideo:bg[count].video,
			}})
		setTimeout(() => {
			this.setState({currentObj :
									{
									...this.state.currentObj,
									bgCount : count,
									title:bg[count].title,
									desc:bg[count].desc,
									btnTitle:bg[count].btnTitle,
									link:bg[count].link,
									posStyle:bg[count].posStyle,
									animationType:bg[count].animationType
									}
								});
		}, bg[count].animationDelay);
	}

	render() {
		const { currentVideo,bgCount,title,desc,btnTitle,link,posStyle,animationType } = this.state.currentObj;
		let marginProp = [1, 15].includes(bgCount) ? "56%" : [13,14].includes(bgCount) ? "35vh" : [0].includes(bgCount) ? "43vh" :"";
		let positionProp = [0,1, 13, 14, 15].includes(bgCount) ? 'relative' : 'fixed';
		let topProp =  [2,8,9].includes(bgCount)? '35%' : bgCount===11 ? '45%' : '';
		return (
			<HollaExWrapper>
				<div className='myVideo'>
					<Player autoPlay={true} src={currentVideo}  muted={true} className='player'>
						<BigPlayButton className='big-play-button-hide'/>
						<Shortcut clickable={false}  dblclickable={false}/>
						<ControlBar autoHide={false} disableDefaultControls={true} disableCompletely={true}/>
					</Player>
					<div className='bg-wrapper-parent' style={{animation: animationType}}>
						<div className={bgCount !== 14 ?
							posStyle : `${posStyle} bg-mid-center` 
							}
							style={{ marginTop:marginProp, position:positionProp , top:topProp}}>
							{title && <div className="bg-wrapper-logo"
									style={{
										animation: bgCount === 0 ? 'mymove-bottom 1s' : '',
										position: 'relative'
									}}>
								<img src={HOLLAEX_WHITE} alt="" />
							</div>}
							<h2>{title}</h2>
							<p>
								{desc}
							</p>
							<div style={{ animation: bgCount === 0 ? 'mymove-top 1s' : '', position: 'relative' }}>
								{title && bgCount !== 14 ?<a
									href={link}
									target="_blank"
									rel="noopener noreferrer"
									className="btn-link"
								>
									{btnTitle}
								</a>:
								bgCount === 14 &&
								<div style={{display:'flex',justifyContent:'center'}}>
									<a
									href={'https://aws.amazon.com/marketplace/pp/prodview-vysn5g3h5cops'}
									target="_blank"
									rel="noopener noreferrer"
									className="btn-link"
									style={{marginRight:'5px'}}
								>
									{btnTitle}
								</a>
								<a
									href={link}
									target="_blank"
									rel="noopener noreferrer"
									className="btn-link"
								>
									DigitalOcean
								</a>
								</div>}
							</div>
						</div>
					</div>
				</div>
			</HollaExWrapper>
		);
	}
}

export default Hollaex;
